import React, { useMemo } from 'react';
import { makeStyles } from '@mui/styles';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import theme from '../../../core/theme';

const useStyles = makeStyles({
  descriptionEditor: {
    width: '100%',
    maxWidth: '100%',
    '& .ql-toolbar': {
      border: '1px solid #d2d2d2',
      borderRadius: '4px'
    },
    '& .ql-container': {
      border: '1px solid #d2d2d2',
      borderRadius: 0,
      height: '100px',
    },
    '& .ql-editor': {
      display: 'block',
      overflowY: 'auto',
      height: '100%',
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
    },
  },
});

const editorStyle = {
  color: theme.palette.primary2.main,
  fontFamily: 'Lato',
  fontSize: '13px',
  lineHeight: 1.38,
  letterSpacing: '0.2px',
};

const editorStyleForOpportunity = {
  ...editorStyle,
  height: '446px',
};

interface Props {
  description: string;
  handleDescriptionChange: (data: string) => void;
  applyClasses?: boolean;
  opportunityDescription?: boolean;
  includeHeadingStyles?: boolean;
}

const RichTextEditorComponent: React.FC<Props> = ({
  description,
  handleDescriptionChange,
  opportunityDescription,
  applyClasses,
  includeHeadingStyles = false,
}) => {
  const classes = useStyles();

  const modules = useMemo(
    () => ({
      toolbar: includeHeadingStyles
        ? [
          [{ header: [1, 2, 3, false] }],
          ['bold', 'italic', 'underline'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link'],
        ]
        : [
          ['bold', 'italic', 'underline'],

          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link'],
        ],
    }),
    [includeHeadingStyles]
  );

  return (
    <ReactQuill
      value={description}
      onChange={handleDescriptionChange}
      modules={modules}
      className={`${classes.descriptionEditor} ${applyClasses ? 'textEditor' : ''}`}
      style={opportunityDescription ? editorStyleForOpportunity : editorStyle}
    />
  );
};

export default RichTextEditorComponent;
